import {
  getVariablesForPair,
  type TemplateChannel,
  type TemplateContext,
  type TemplateVariableDefinition,
} from '@fluenceur/types';
import type { AvailableVariable } from '@fluenceur/ui';

import { buildSampleValues } from './template-library-utils';

/**
 * Adapt a pair's variable definitions to the editor's `AvailableVariable`
 * shape. Each variable is given its sample value so the insert-variable menu
 * and typeahead stay enabled (they disable variables that have no value).
 */
export const toAvailableVariables = (
  variables: readonly TemplateVariableDefinition[]
): AvailableVariable[] => {
  const sampleValues = buildSampleValues(variables);
  return variables.map((variable) => ({
    key: variable.key,
    label: variable.label,
    labelKey: variable.labelKey,
    description: variable.description,
    descriptionKey: variable.descriptionKey,
    required: variable.required,
    value: sampleValues[variable.key] ?? null,
  }));
};

/** Editor variables for a (channel, context) pair. */
export const availableVariablesForPair = (
  channel: TemplateChannel,
  context: TemplateContext
): AvailableVariable[] => toAvailableVariables(getVariablesForPair(channel, context));

/** Sample value map for previewing a (channel, context) pair. */
export const sampleValuesForPair = (
  channel: TemplateChannel,
  context: TemplateContext
): Record<string, string> => buildSampleValues(getVariablesForPair(channel, context));
